<template src="./PasswordResetForm.html"/>
<style lang='scss' scoped src="./PasswordResetForm.scss"/>

<script>

import {SfInput, SfButton, SfNotification} from '@storefront-ui/vue';
import Api from "@/api/Api";

export default {
  name: 'PasswordResetForm',

  components: {
    SfInput,
    SfNotification,
    SfButton
  },
  props: {
    token: {
      default: null,
      type: String || null
    }
  },
  data() {
    return {
      isSuccess: false,
      isError: false,
      loading: false,
      error: null,
      valid: false,
      submitted: false,
      newPasswordError: null,
      repeatPasswordError: null,
      newPassword: "",
      newPasswordBlur: true,
      repeatPassword: "",
      repeatPasswordBlur: true,
    }
  },
  methods: {
    validate() {
      this.newPasswordBlur = false;
      this.newPasswordBlur = false
      if (this.validRepeatPassword(this.repeatPassword) && this.validNewPassword(this.newPassword)) {
        this.valid = true;
      }
    },
    validNewPassword(newPassword) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (regex.test(newPassword)) {
        this.newPasswordError = null;
        return true
      } else {
        this.newPasswordError = this.$i18n.t('password.error');
        return false
      }
    },
    validRepeatPassword(repeatPassword) {
      if (this.newPassword === repeatPassword) {
        this.repeatPasswordError = null;
        return true;
      } else {
        this.repeatPasswordError = this.$i18n.t('repeatPassword.error');
        return false
      }
    },
    handleResetPassword() {
      this.validate();
      if (this.valid) {
        this.loading = true;
        let status = '';
        Api.account.changeResetPassword({newPassword: this.newPassword, resetToken: this.token}).then(() => {
          status = 'valid'
        }).catch((e) => {
          status = 'error'
        }).finally(() => {
          this.loading = false;
          this.$emit('modal', status)
        })
      }
    }
  }
};
</script>


